import styled, { css } from 'styled-components';
import React, { useMemo } from 'react';
import { Dropdown } from 'react-bootstrap';

import { ThreeDots } from '@/assets/icons';
import { colors } from '@/styles/colors';

interface IProps {
  className?: string;
  options: {
    label: string;
    callback: React.MouseEventHandler;
  }[];
  separators?: number[];
}

interface ICustomToggleProps {
  onClick: React.MouseEventHandler<HTMLImageElement>;
}

const getStyledCustomToggle = (className?: string) =>
  React.forwardRef<HTMLImageElement, ICustomToggleProps>(function CustomToggle({ onClick }, ref) {
    return (
      <ButtonMenu
        src={ThreeDots}
        ref={ref}
        onClick={e => {
          e.preventDefault();
          onClick(e);
        }}
        className={className}
      />
    );
  });

const DropdownMenu = ({ options, className, separators }: IProps): React.ReactElement => {
  const CustomToggle = useMemo(() => getStyledCustomToggle(className), [className]);

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} />
      <Dropdown.Menu>
        {options.map(({ label, callback }, idx) => (
          <React.Fragment key={label}>
            <Dropdown.Item as={MenuItem} eventKey={idx} onClick={callback}>
              {label}
            </Dropdown.Item>
            {separators?.includes(idx) && <Dropdown.Divider />}
          </React.Fragment>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export { DropdownMenu };

const ButtonMenu = styled.img`
  height: 16px;
  width: 100%;
  cursor: pointer;
`;

const MenuItem = styled.div<{ hasSeparator?: boolean }>`
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 500;
  color: ${colors.gray.c800};
  cursor: pointer;

  &:hover {
    background-color: ${colors.gray.c100};
  }

  &:first-child {
    padding-top: 14px;
  }

  &:last-child {
    padding-bottom: 14px;
  }

  ${({ hasSeparator }) =>
    hasSeparator &&
    css`
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    `}
`;
